"use client";
import {
  ShieldCheck,
  WandSparkles,
} from "lucide-react";
import {
  type ScanReport,
} from "../../../lib/types";


export function CodeQualityView({ report }: { report: ScanReport }) {
  const assessment = report.codeQuality;
  return (
    <div className="view-stack">
      <section className="panel">
        <div className="panel-heading">
          <div>
            <div className="section-kicker">AI-STYLE CODE SIGNALS</div>
            <h3>{assessment.label}</h3>
          </div>
          <span>{assessment.score}/100 signal score</span>
        </div>
        <div className="quality-summary">
          <WandSparkles size={28} />
          <div>
            <strong>{assessment.confidence} confidence</strong>
            <p>{assessment.disclaimer}</p>
          </div>
        </div>
        <div className="quality-signal-list">
          {assessment.signals.map((signal) => (
            <article key={signal.id}>
              <span>+{signal.weight}</span>
              <div>
                <strong>{signal.label}</strong>
                <p>{signal.detail}</p>
                <div>
                  {signal.evidence.map((evidence) => (
                    <code key={evidence}>{evidence}</code>
                  ))}
                </div>
              </div>
            </article>
          ))}
          {!assessment.signals.length && (
            <div className="empty-panel">
              <ShieldCheck size={25} />
              <strong>No meaningful AI-style markers</strong>
              <span>
                JarLab found no explicit assistant text or strong structural
                pattern. This does not prove human authorship.
              </span>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
